import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { switchMap, map } from 'rxjs/operators';
import { scheduleHeaderData, scheduleHeader } from '../../../interfaces/OT/scheduleHeader';
import { otscheduleApi } from '../api/otschedule.api';

@Injectable() 
export class otscheduleService extends scheduleHeaderData{
 
  constructor(private api: otscheduleApi) {
    super();
  } 
  
  getall(url: string): Observable<scheduleHeader[]> { 
    return this.api.getall(url);
  } 

  getById(url:string): Observable<scheduleHeader>{
      return this.api.getby_id(url);
  }

  create(url: string, data:any): Observable<any> {
    return this.api.add(url,data);
  }

  update(url: string, data:scheduleHeader): Observable<scheduleHeader> { 
    return this.api.update(url,data);
  }  

  list(url: string): Observable<any> {
    return this.api.list(url);
  }

  searchList(url: string,data:any): Observable<any> {  
    return this.api.searchList(url,data);
  }
  delete(url: string): Observable<boolean> {
    return this.api.delete(url);
  }
}
